const copyVisitIdToClipboard = (utils, visit) => {
  const {
    id,
    user: { firstname, lastname } = {},
  } = { ...visit };

  navigator.clipboard.writeText(
    `${id || ''}${id && (firstname || lastname) ? ' ' : ''}${
      utils.getFirstLetterUppercase(firstname) || ''
    }${utils.getFirstLetterUppercase(lastname) || ''}`
  );
};

(() => {
  copyToClipboard.$inject = ['Utils'];

  function copyToClipboard(Utils) {
    return {
      restrict: 'A',
      scope: {
        copyToClipboard: '=',
        visit: '=?',
      },
      link: function (scope, element) {
        element.bind('click', function (event) {
          scope.copyToClipboard
            ? navigator.clipboard.writeText(scope.copyToClipboard)
            : copyVisitIdToClipboard(Utils, scope.visit);

          event.preventDefault();
        });
      },
    };
  }

  angular.module('pims').directive('copyToClipboard', copyToClipboard);
})();
